<script setup lang="ts">
interface IProps {
  value: string
  color?: string
  height?: number
}

const props = withDefaults(defineProps<IProps>(), {
  color: '#5c8ffa',
  height: 4,
})

const barHeight = computed(() => `${props.height}px`)
const valueColor = computed(() => props.color)
</script>

<template>
  <progress
    max="100"
    :value="value"
    class="progress-bar"
  >
    {{ value }}%
  </progress>
</template>

<style scoped lang="scss">
.progress-bar {
  @apply w-full h-[v-bind(barHeight)];

  &::-webkit-progress-bar {
    @apply bg-primary/10;
  }

  &::-webkit-progress-value {
    border-radius: 16px;
    background-color: v-bind(valueColor);
  }
}
</style>